<template>
  <div class="footer-area__newsletter">
    <h4 class="footer-area__newsletter__title">rimani aggiornato con le novità e promozioni</h4>
    <form 
      action="https://colorificiopostumia.us3.list-manage.com/subscribe/post?u=5e131187395348bc808491f71&amp;id=1e86634c1f" 
      method="post" 
      id="mc-embedded-subscribe-form" 
      name="mc-embedded-subscribe-form" 
      class="validate c-form-newsletter" 
      target="_blank"
      @submit="checkForm"
      novalidate>
      
      <input 
        v-model="email"
        :class="{'error': erroreEmail}"
        type="email" 
        name="EMAIL" 
        placeholder="indirizzo email"
        class="required email"
        id="mce-EMAIL">
      
      <button 
        class="c-btn"
        title="Subscribe"
        name="subscribe"
        id="mc-embedded-subscribe">
        <span>Iscriviti</span>
      </button>

      <div style="position: absolute; left: -5000px;" aria-hidden="true">
        <input type="text" name="b_5e131187395348bc808491f71_1e86634c1f" tabindex="-1" value="">
      </div>

      <div class="footer-area__newsletter__checkbox">
        <p>Ai sensi e per gli effetti degli artt. 7, 12, 13 ss. del Reg. UE 2016/679 - GDPR:</p>
        <div>

          <input 
            v-model="privacy" 
            :class="{'error': errorePrivacy}" 
            id="privacy" 
            class="checkbox-custom" 
            name="checkbox-2" 
            type="checkbox">

          <label for="privacy" class="checkbox-custom-label"> acconsento al trattamento dei miei dati personali per ricevere Newsletter come da <router-link :to="{ name: 'single-page', params: { slug: 'privacy-policy' } }">Privacy Policy</router-link>.</label>
        </div>
        <div id="mce-responses" class="clear">
          <div class="response" id="mce-error-response" style="display:none"></div>
          <div class="response" id="mce-success-response" style="display:none"></div>
        </div>
      </div>
    </form>

  </div>
</template>

<script>

import { mapGetters } from 'vuex'
export default {
  name: 'FooterAreaNewsletter',
  data: () => ({
    privacy: false,
    email: '',
    errorePrivacy: false,
    erroreEmail: false
  }),
  methods:{
    checkForm(e){
      var errori = false
      this.errorePrivacy = false
      this.erroreEmail = false
      if (!this.privacy) {
        this.errorePrivacy = true
        errori = true
      }
      if (!this.email || !this.validEmail(this.email)) {
        this.erroreEmail = true
        errori = true
      }
      if (!errori) return
      e.preventDefault()
    },
    validEmail: function (email) {
      var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      return re.test(email)
    }
  }
}
</script>

<style lang="scss">
  @import "./newsletter.scss";
</style>
